import { useQuery } from '@tanstack/react-query';
import { getOAuthClientInfo } from '@/features/auth/api/oauth.api';

export const oauthQueryKeys = {
  client: (clientId?: string) => ['oauth', 'client', clientId] as const,
} as const;

export function useOAuthClientInfo(clientId?: string) {
  return useQuery({
    queryKey: oauthQueryKeys.client(clientId),
    queryFn: () => getOAuthClientInfo(clientId!),
    enabled: !!clientId,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
